import { PreviewPrintOrderRequest, RenderPrintOrderRequest } from '@bringg/types';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';

import { HtmlSanitizer, printHtml } from './print-html';

const printReceipt = async (payload: RenderPrintOrderRequest, sanitize: HtmlSanitizer): Promise<void> => {
	const html = await getRootEnv().dashboardSdk.sdk.templatesApi.receipt(payload);

	printHtml(html, sanitize);
};

const printPreview = async (payload: PreviewPrintOrderRequest, sanitize: HtmlSanitizer): Promise<void> => {
	const html = await getRootEnv().dashboardSdk.sdk.templatesApi.preview(payload);

	printHtml(html, sanitize);
};

export const orderReceiptPrintingProvider = {
	printReceipt,
	printPreview
};
